// Utils
import get from 'lodash/get';
import { setTrackingProperty } from '../../helper';

// Types
import type { TrackFormSubmitArgs } from '../../types/tracking';
import type { Input } from '../../types/Field';
import type { InputTypeMap } from '../../types/InputTypeMap';
import type { MappedFormValues } from '../../types/tracking';

export const getNowISO = () => {
    return new Date().toISOString();
};

// Map the form values (from form submit) to its input fields
export const createMappedFormValues = ({
    values,
    formId,
    inputFieldList,
    inputMap,
}: {
    values: { [key: string]: any };
    formId: string;
    inputFieldList: Input[];
    inputMap: InputTypeMap;
}): MappedFormValues => {
    return Object.keys(values)
        .filter((fieldName) => !!values[fieldName])
        .map((fieldName) => {
            const inputId = inputMap?.byName[formId][fieldName];
            const inputField = inputFieldList.find(({ componentId }: { componentId: string }) => {
                return componentId === inputId;
            });

            let value = values[fieldName];

            if (inputField) {
                if (inputField.inputType === 'checkbox' && typeof value === 'string') {
                    value = value === 'true';
                }

                return {
                    inputField: inputField,
                    value,
                    conversionTrigger: inputField.conversionTrigger,
                };
            }

            return null;
        })
        .filter(Boolean);
};

// Update trackingProperties in the Session storage with the form values for personalization
// Called after submitting a form
export const updateTrackingProperties = ({
    form,
    values,
    fields,
    inputMap,
}: Omit<TrackFormSubmitArgs, 'button'>) => {
    const formField = fields.find(({ additional }) => {
        return get(additional, 'form.componentId') === form._id;
    });

    if (!formField) {
        return;
    }

    const campaignId = formField.campaignId;
    const inputFieldList = get(formField, 'additional.form.inputs');

    // Map the form values to the input fields
    const mappedFormValues = createMappedFormValues({
        values,
        formId: form._id,
        inputFieldList,
        inputMap,
    });

    mappedFormValues.forEach((mappedFormValue) => {
        if (mappedFormValue) {
            setTrackingProperty(
                mappedFormValue.inputField.fieldName,
                mappedFormValue.value,
                campaignId,
            );
        }
    });
};
